import { useState } from "react";
import { AppBar, Toolbar } from "@mui/material";
import { Box, styled } from "@mui/system";

import SideDrawer from "./SideDrawer";
import ResponsiveAppBar from "./AppBar";
import useClasses from "../utils";

const styles = theme => ({
  drawerPaper: {
    width: drawerWidth,
    display: "grid",
    gridTemplateRows: "auto auto 1fr auto",
  },
});

const MainStyle = styled("main")(({ theme }) => ({
  flexGrow: 1,
  minHeight: "100vh",
  padding: theme.spacing(2.5),
}));

const DashboardLayout = (props) => {
  return (
    <>
      <ResponsiveAppBar/>
      <Box sx={{ display: "flex" }}>
        <MainStyle>
          {/* Main parts */}
          {props.children}
        </MainStyle>
      </Box>
    </>
  );
};

export default DashboardLayout;

export const drawerWidth = 150;
